import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=7c0223a8&scoped=true&"
import script from "./Step.vue?vue&type=script&lang=js&"
export * from "./Step.vue?vue&type=script&lang=js&"
import style0 from "./Step.vue?vue&type=style&index=0&id=7c0223a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0223a8",
  null
  
)

export default component.exports